import {
    Flex,
    Grid,
    Text,
    Box,
    useColorModeValue
} from "@chakra-ui/react";
import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';

function PdfCard({ src, title }) {
  const [exists, setExists] = useState(false);

  useEffect(() => {
    fetch(src, { method: 'HEAD' }).then(res => {
      setExists(res.ok && res.headers.get('content-type')?.includes('pdf'));
    }).catch(() => setExists(false));
  }, [src]);

  if (!exists) return null;

  return (
    <Box mb="24px">
      <iframe
        src={src}
        width="100%"
        height="1200"
        style={{ border: '1px solid #e2e8f0', borderRadius: '8px' }}
        title={title}
      />
    </Box>
  );
}

export default function Default() {
  const { t } = useTranslation('certifications');
  const textColor = useColorModeValue("gray.700", "white");

  const patents = [
    { src: "/patentsCertifications/tgcam_patent_1.pdf", title: "Patent 1" },
  ];

  const certifications = [
    { src: "/patentsCertifications/TNC-BP516AFS_KC.pdf", title: "TNC-BP516AFS KC" },
    { src: "/patentsCertifications/TNC-BP516AFS.pdf", title: "TNC-BP516AFS" },
  ];

  return (
    <Flex flexDirection="column" pt={{ base: "120px", md: "75px" }} px="20px">
      <Text
        color={textColor}
        fontWeight="bold"
        fontSize="3xl"
        mb="30px"
      >
        {t('title')}
      </Text>

      <Box mb="40px">
        <Text fontSize="lg" color={textColor} fontWeight="bold" mb="16px">
          {t('patent')}
        </Text>
        {patents.map((p) => (
          <PdfCard key={p.src} src={p.src} title={p.title} />
        ))}
      </Box>

      <Box mb="40px">
        <Text fontSize="lg" color={textColor} fontWeight="bold" mb="16px">
          {t('certification')}
        </Text>
        {certifications.map((c) => (
          <PdfCard key={c.src} src={c.src} title={c.title} />
        ))}
      </Box>
    </Flex>
  );
}
